import React, { useState } from 'react';
import PatientControlButton from 'components/atoms/patentControlButton';
import { useTranslation } from 'react-i18next';
import EHRControlIcon from 'components/atoms/icons/ehrControlIcon';
import CreateCaseInEhrModalNew from 'components/molecules/create-case-in-ehr';
import { useCreateCaseInEhr } from 'infrastructure/hooks/control-panel/use-create-case-in-ehr';
import { useAccess } from 'infrastructure/hooks/access/useAccess';

import type { ModuleType } from 'infrastructure/enums';

interface IProps {
  module: ModuleType;
  patientGuid: string;
}

const EhrControl: React.FC<IProps> = (props) => {
  const { module, patientGuid } = props;
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const {
    isCombinedModule,
    isReadOnlyRole,
    isBlockCcmModule,
    isBlockRpmModule,
    isCcmActionDisabled,
  } = useAccess({
    module,
    patientGuid,
  });

  const { createCaseInEhr, createCaseInEhrLoading } = useCreateCaseInEhr({
    onSuccess() {
      setOpen(false);
    },
  });

  return (
    <>
      <PatientControlButton
        label={t('labels.createCaseInEHR')}
        Icon={EHRControlIcon}
        loading={createCaseInEhrLoading}
        disabled={isCombinedModule ? isReadOnlyRole : isCcmActionDisabled}
        handleClick={() => setOpen(true)}
      />

      <CreateCaseInEhrModalNew
        isOpen={open}
        toggle={() => setOpen(false)}
        module={module}
        patientGuid={patientGuid}
        submit={createCaseInEhr}
        loading={createCaseInEhrLoading}
        tabsProps={{
          showTabs: isCombinedModule,
          disableCcm: isBlockCcmModule,
          disableRpm: isBlockRpmModule,
        }}
      />
    </>
  );
};

export default EhrControl;
